function commentNode(el, vnode) {
	const comment = document.createComment('')

	Object.defineProperty(comment, 'setAttribute', {
		value: () => undefined
	})

	vnode.text = ''
	vnode.elm = comment
	vnode.isComment = true
	vnode.context = undefined
	vnode.tag = undefined
	vnode.data.directives = undefined

	if (vnode.componentInstance) {
		vnode.componentInstance.$el = comment
	}

	if (el.parentNode) {
		el.parentNode.replaceChild(comment, el)
	}
}

function checkPermissionImplementation (el, binding, vnode) {
	const permission = binding.value
	const store = vnode.context.$store
	const user_uid = store.state.user.uid

	let show = false

	if (store.getters.isAdmin) {
		show = true
	} else if (permission.user_uid) {
		show = permission.user_uid == user_uid || store.getters.checkUserPermission(permission.user_uid, permission.area)
	} else if (permission.watch_id) {
		show = store.getters.checkWatchPermission(user_uid, permission.watch_id, permission.area)
	}

	if (!show) {
		commentNode(el, vnode)
	}
}

function checkUserPermissionImplementation (el, binding, vnode) {
	const permission_user_uid = binding.value
	const permission_area = binding.arg
	const store = vnode.context.$store

	let show = false

	if (store.getters.isAdmin) {
		show = true
	} else if (permission_user_uid && permission_area) {
		const user_uid = store.state.user.uid
		show = permission_user_uid == user_uid || store.getters.checkUserPermission(permission_user_uid, permission_area)
	}

	if (!show) {
		commentNode(el, vnode)
	}
}

function checkGroupPermissionImplementation (el, binding, vnode) {
	const permission_user_uid = binding.value.user_uid
	const permission_group_id = binding.value.group_id
	const store = vnode.context.$store

	let show = false

	if (store.getters.isAdmin) {
		show = true
	} else if (permission_group_id) {
		show = store.getters.checkGroupPermission(permission_user_uid, permission_group_id)
	}

	if (!show) {
		commentNode(el, vnode)
	}
}

function checkWatchPermissionImplementation (el, binding, vnode) {
	const permission_watch_id = binding.value
	const permission_area = binding.arg
	const store = vnode.context.$store

	let show = false

	if (store.getters.isAdmin) {
		show = true
	} else if (permission_watch_id && permission_area) {
		const user_uid = store.state.user.uid
		show = store.getters.checkWatchPermission(user_uid, permission_watch_id, permission_area)
	}

	if (!show) {
		commentNode(el, vnode)
	}
}

const checkPermission = {
	bind: checkPermissionImplementation,
	update: checkPermissionImplementation
}

const checkUserPermission = {
	bind: checkUserPermissionImplementation,
	update: checkUserPermissionImplementation
}

const checkGroupPermission = {
	bind: checkGroupPermissionImplementation,
	update: checkGroupPermissionImplementation
}

const checkWatchPermission = {
	bind: checkWatchPermissionImplementation,
	update: checkWatchPermissionImplementation
}

export { checkPermission, checkUserPermission, checkGroupPermission, checkWatchPermission }



// WEBPACK FOOTER //
// ./src/directives/CheckPermission.js